<template>
    <v-dialog v-model="$store.state.groupFSC.history" max-width="1300px" transition="dialog-transition" persistent>
        <v-card>
            <v-toolbar color="secondary" dark dense>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    History FSC
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="$store.state.groupFSC.history = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-row justify="center">
                    <v-col cols="3">
                        <v-text-field label="Start Date" id="StartDate" v-model="startDate" placeholder="yyyy-mm-dd"
                            v-mask="'####-##-##'" hide-details :rules="dateRules" required></v-text-field>
                    </v-col>
                    <v-col cols="3">
                        <v-text-field label="End Date" id="EndDate" v-model="endDate" placeholder="yyyy-mm-dd"
                            v-mask="'####-##-##'" hide-details :rules="dateRules" required></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4">
                        <v-text-field
                            label="Search Group"
                            v-model="search"
                            dense 
                            hide-details
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th>Group</th>
                                    <th>Region Group</th>
                                    <th>FSC</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(itm, idx) in filteredItems" v-bind:key="idx">
                                    <td>
                                        {{ itm.name }}
                                    </td>
                                    <td>
                                        <v-combobox v-model="itm.InvoiceGrp" :items="invoiceGroup" required
                                            :item-text="'InvoiceGroup'" :item-value="'InvoiceGroupID'" dense hide-details
                                            auto-select-first class="mx-6"></v-combobox>
                                    </td>
                                    <td>
                                        <v-text-field v-model="itm.FSC" hide-details dense></v-text-field>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
                <v-row justify="end">
                    <v-btn color="secondary" small class="mr-5 mb-5" @click="saveHistory">Save</v-btn>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
export default {
    props: ['groupCustomers'],
    directives: { mask },
    data: function () {
        return {
            group: null,
            invoiceGroup: null,
            arrGroup: [],
            search:null,
            headers: [
                { text: 'Group', value: 'Group' },
                { text: 'Region', value: 'Region' },
                { text: 'FSC', value: 'FSC' },

            ]

        };
    },
    async mounted() {
        this.loadInvoiceGroup();
    },
    computed:{
        filteredItems() {

            return this.arrGroup.filter(item => {
                // Filtrar por nombre en minúsculas
                return !this.search || item.name.toLowerCase().includes(this.search.toLowerCase());
            });
            // return this.arrGroup.filter(i => {
            //     return !this.search || i.name == this.search;
            // });
        },
    },
    methods: {
        saveHistory: function(){
            var str = this.$store;
            var parms = {
                
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                groups: this.filteredItems.filter(x =>{
                    return x.InvoiceGrp != null;
                }),

            }
            console.log(parms);
            axios
                .post('invoice-history-group/register', parms,{
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                            color: 'success',
                            text:
                                'FSC History Successfully Saved'
                        });

                    this.arrGroup = [];
                        this.groupCustomers.forEach(element => {
                        var arr = {
                            name: element.GroupName,
                            group: element,
                            FSC: null,
                            InvoiceGrp: null,
                        }
                        this.arrGroup.push(arr);
                    });
                    this.$emit('close');
                        
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        loadInvoiceGroup: function () {
            axios
                .get('invoice-group', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.invoiceGroup = response.data;
                    this.groupCustomers.forEach(element => {
                        var arr = {
                            name: element.GroupName,
                            group: element,
                            FSC: null,
                            InvoiceGrp: null,
                        }
                        this.arrGroup.push(arr);
                    });
                    console.log(this.arrGroup)
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }
};
</script>
